import { Box, BoxProps } from "@mui/material";

interface IWfDialogFooterProps extends BoxProps {}

export const WfDialogFooter = ({ children, ...props }: IWfDialogFooterProps) => {
    return (
        <Box
            position={{ xs: "absolute", sm: "static" }}
            bottom={{ xs: "24px", sm: "unset" }}
            width={{ xs: "calc(100% - 48px)", sm: "auto" }}
            {...props}
        >
            {children}
        </Box>
    );
};
